(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    (function() {
    var button = document.querySelector('[data-back-to-top]');
    if (!button) return;

    function onScroll() {
      button.hidden = window.scrollY < 460;
    }

    button.addEventListener('click', function() {
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    });

    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["faceted-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(event) {
    const checkbox = event.target.closest('[data-filter-checkbox]');
    const form = checkbox && checkbox.closest('[data-faceted-form]');
    if (form && !form.hasAttribute('data-manual-apply')) form.requestSubmit();
  });
  document.addEventListener('input', function(event) {
    const input = event.target.closest('[data-filter-search]');
    if (!input) return;
    const group = input.closest('.faceted-filters__group-body');
    const query = input.value.trim().toLocaleLowerCase();
    let visible = 0;
    group.querySelectorAll('.faceted-filters__list-item').forEach(item => {
      const text = item.querySelector('.faceted-filters__value-text').textContent.toLocaleLowerCase();
      item.hidden = !text.includes(query);
      if (!item.hidden) visible++;
    });
    group.querySelector('[data-filter-no-options]').hidden = visible > 0;
  });
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Enter' && event.target.matches('[data-filter-search]')) event.preventDefault();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    (function() {
    document.querySelectorAll('[data-predictive-search]').forEach(function(root) {
      var input = root.querySelector('[data-predictive-input]');
      var results = root.querySelector('[data-predictive-results]');
      if (!input || !results) return;
      var noResultsLabel = root.getAttribute('data-no-results-label') || 'No results';
      var errorLabel = root.getAttribute('data-error-label') || 'Search is temporarily unavailable';
      var productLabel = root.getAttribute('data-product-label') || 'Product';
      var articleLabel = root.getAttribute('data-article-label') || 'Article';
      var pageLabel = root.getAttribute('data-page-label') || 'Page';

      var controller;

      function renderEmpty() {
        results.innerHTML = '<p class="predictive-search__empty">' + noResultsLabel + '</p>';
        results.hidden = false;
      }

      function renderError() {
        results.innerHTML = '<p class="predictive-search__empty">' + errorLabel + '</p>';
        results.hidden = false;
      }

      function renderItems(items) {
        if (!items.length) {
          renderEmpty();
          return;
        }

        var html = '<ul class="predictive-search__list" role="list">';
        items.slice(0, 7).forEach(function(item) {
          html += '<li class="predictive-search__item">';
          html += '<a href="' + item.url + '">';
          html += '<span class="predictive-search__title">' + item.title + '</span>';
          html += '<span class="predictive-search__type">' + item.type + '</span>';
          html += '</a></li>';
        });
        html += '</ul>';

        results.innerHTML = html;
        results.hidden = false;
      }

      function parseItems(data) {
        var resources = (data.resources && data.resources.results) || {};
        var items = [];

        (resources.products || []).forEach(function(p) {
          items.push({ title: p.title, url: p.url || '#', type: productLabel });
        });
        (resources.articles || []).forEach(function(a) {
          items.push({ title: a.title, url: a.url || '#', type: articleLabel });
        });
        (resources.pages || []).forEach(function(pg) {
          items.push({ title: pg.title, url: pg.url || '#', type: pageLabel });
        });

        return items;
      }

      function fetchPredictive(term) {
        if (!term || term.length < 2) {
          results.hidden = true;
          results.innerHTML = '';
          return;
        }

        if (controller) controller.abort();
        controller = new AbortController();

        var query = 'q=' + encodeURIComponent(term) + '&resources[type]=product,page,article&resources[limit]=4';
        var endpoint = root.getAttribute('data-predictive-url');

        fetch(endpoint + '?' + query, { signal: controller.signal })
          .then(function(res) {
            if (!res.ok) throw new Error('predictive-search-request-failed');
            return res.json();
          })
          .then(function(data) {
            renderItems(parseItems(data));
          })
          .catch(function(error) {
            if (error.name === 'AbortError') return;
            renderError();
          });
      }

      input.addEventListener('input', function() {
        fetchPredictive(input.value.trim());
      });

      document.addEventListener('click', function(event) {
        if (!root.contains(event.target)) {
          results.hidden = true;
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.__petsSOUKQuickAddInit) return;
    window.__petsSOUKQuickAddInit = true;

    function updateCartCount(count) {
      var toggles = document.querySelectorAll('[data-cart-toggle]');
      toggles.forEach(function(toggle) {
        var badge = toggle.querySelector('.header__cart-count');
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'header__cart-count';
            toggle.appendChild(badge);
          }
          badge.textContent = String(count);
        } else if (badge) {
          badge.remove();
        }
      });
    }

    function refreshCartState() {
      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      fetch(rootPath + 'cart.js')
        .then(function(res) { return res.ok ? res.json() : null; })
        .then(function(cart) {
          if (!cart) return;
          updateCartCount(cart.item_count || 0);
        })
        .catch(function() {});
    }

    document.addEventListener('click', function(event) {
      var stepper = event.target.closest('[data-quick-add-step]');
      if (stepper) {
        var qtyWrap = stepper.closest('[data-quick-add-qty-wrap]');
        if (!qtyWrap) return;
        var qtyInput = qtyWrap.querySelector('[data-quick-add-qty]');
        if (!qtyInput) return;
        var step = parseInt(stepper.getAttribute('data-quick-add-step'), 10) || 0;
        var current = parseInt(qtyInput.value, 10);
        if (!Number.isFinite(current) || current < 1) current = 1;
        qtyInput.value = Math.max(1, current + step);
        return;
      }

      var optionBtn = event.target.closest('[data-variant-option]');
      if (!optionBtn) return;
      var form = optionBtn.closest('[data-quick-add-form]');
      if (!form) return;
      var variantInput = form.querySelector('[data-quick-add-variant]');
      var submit = form.querySelector('[data-quick-add-submit]');
      if (!variantInput || !submit) return;

      form.querySelectorAll('[data-variant-option]').forEach(function(btn) {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-pressed', 'false');
      });

      optionBtn.classList.add('is-active');
      optionBtn.setAttribute('aria-pressed', 'true');
      variantInput.value = optionBtn.getAttribute('data-variant-id') || '';

      var isAvailable = optionBtn.getAttribute('data-variant-available') === 'true';
      submit.disabled = !isAvailable;
      submit.textContent = isAvailable ? (submit.getAttribute('data-label-default') || '') : (submit.getAttribute('data-label-unavailable') || '');
    });

    document.addEventListener('submit', function(event) {
      var form = event.target.closest('[data-quick-add-form]');
      if (!form) return;
      event.preventDefault();

      var submit = form.querySelector('[data-quick-add-submit]');
      if (!submit || submit.disabled) return;

      var defaultLabel = submit.getAttribute('data-label-default') || submit.textContent;
      var addingLabel = submit.getAttribute('data-label-adding') || defaultLabel;
      var addedLabel = submit.getAttribute('data-label-added') || defaultLabel;
      var unavailableLabel = submit.getAttribute('data-label-unavailable') || defaultLabel;

      var formData = new FormData(form);
      var endpoint = form.getAttribute('action') || '/cart/add';
      if (!endpoint.endsWith('.js')) endpoint += '.js';

      submit.classList.add('is-loading');
      submit.textContent = addingLabel;

      fetch(endpoint, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
        .then(function(res) {
          if (!res.ok) throw new Error('add_failed');
          return res.json();
        })
        .then(function(item) {
          submit.textContent = addedLabel;
          refreshCartState();
          // Dispatch cart:updated event to trigger drawer refresh
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { openDrawer: true, item: item },
            bubbles: true
          }));
          window.setTimeout(function() {
            submit.textContent = defaultLabel;
          }, 1300);
        })
        .catch(function() {
          submit.textContent = unavailableLabel;
          submit.disabled = true;
        })
        .finally(function() {
          submit.classList.remove('is-loading');
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(e) {
    var minusBtn = e.target.closest('[data-quantity-minus]');
    var plusBtn = e.target.closest('[data-quantity-plus]');
    if (!minusBtn && !plusBtn) return;

    var container = (minusBtn || plusBtn).closest('.quantity-selector');
    var input = container.querySelector('.quantity-selector__input');
    var currentVal = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 99;

    if (minusBtn && currentVal > min) {
      input.value = currentVal - 1;
    } else if (plusBtn && currentVal < max) {
      input.value = currentVal + 1;
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-tiers"] && !Shopify.designMode) return;
  try {
    function quantityOfferSelection(data, ids, percent) {
    const items = new Map();
    let total = 0, original = 0, birds = 0;
    for (const id of ids) {
      const v = data.variants[String(id)];
      if (!v || !v[1]) return {error: true};
      original += v[0];
      total += v[0] - Math.floor(v[0] * percent / 100);
      birds += v[3];
      const line = items.get(String(id)) || {id: String(id), quantity: 0};
      line.quantity++;
      items.set(String(id), line);
    }
    for (const item of items.values()) {
      const v = data.variants[item.id];
      if (item.quantity > v[2] || item.quantity < v[4] || (item.quantity - v[4]) % v[5] !== 0) return {error: true};
    }
    return {items: Array.from(items.values()), total: total, original: original, birds: birds};
  }
  function quantityOfferMoney(cents, sample) {
    const match = sample.match(/\d[\d.,\s'’]*\d/);
    if (!match) return String(cents / 100);
    const number = match[0].trim();
    const decimal = /[.,]89$/.test(number) ? number.slice(-3,-2) : '';
    const integerSample = decimal ? number.slice(0,-3) : number;
    const group = integerSample.replace(/\d/g, '').slice(-1);
    const parts = (cents / 100).toFixed(decimal ? 2 : 0).split('.');
    const integer = group ? parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, group) : parts[0];
    return sample.slice(0,match.index) + integer + (decimal ? decimal + parts[1] : '') + sample.slice(match.index + match[0].length);
  }
  function initQuantityOffers(scope) {
    scope.querySelectorAll('[data-qtiers]:not([data-qtiers-ready])').forEach(function(root) {
      const form = root.closest('form');
      const qty = form && form.querySelector('input[name="quantity"]');
      const variant = form && form.querySelector('[data-product-variant-id]');
      if (!qty || !variant) return;
      const data = JSON.parse(root.querySelector('[data-qtiers-data]').textContent);
      const rows = Array.from(root.querySelectorAll('[data-qtiers-opt]'));
      const summary = root.querySelector('[data-qtiers-summary]');
      const quantityControl = root.querySelector('[data-qtiers-quantity]');
      const countInput = root.querySelector('[data-qtiers-count-input]');
      const decrease = root.querySelector('[data-qtiers-decrease]');
      const increase = root.querySelector('[data-qtiers-increase]');
      const choices = root.querySelector('[data-qtiers-choices]');
      const itemTemplate = choices && choices.querySelector('[data-qtiers-item]').cloneNode(true);
      const errorNode = root.querySelector('[data-qtiers-error]');
      const checkoutNote = root.querySelector('[data-qtiers-checkout-note]');
      const checkout = form.querySelector('[data-dynamic-checkout-wrapper]');
      const labelsNode = form.querySelector('[data-product-label-map]');
      const labels = labelsNode ? JSON.parse(labelsNode.textContent) : {};
      const eligible = Object.values(data.variants).every(v => v[4] === 1 && v[5] === 1);
      const canMix = root.dataset.mixEnabled === 'true' && eligible;
      let previousVariant = String(variant.value);
      const slots = Array.from({length: 3}, () => ({id: previousVariant, dirty: false}));
      const money = cents => quantityOfferMoney(cents, data.moneySample);
      const percentFor = count => count >= 3 ? data.percentages['3'] : count === 2 ? data.percentages['2'] : 0;
      function ensureSlots(count) {
        while (slots.length < count) slots.push({id: String(variant.value), dirty: false});
      }
      const selectionFor = count => {
        ensureSlots(count);
        return quantityOfferSelection(data, canMix && count >= 2 ? slots.slice(0,count).map(s => s.id) : Array(count).fill(String(variant.value)), percentFor(count));
      };
      function ensureRows(count) {
        if (!choices || !canMix) return;
        let index = choices.querySelectorAll('[data-qtiers-item]').length;
        while (index < count) {
          const item = itemTemplate.cloneNode(true);
          item.dataset.qtiersItem = index;
          item.querySelector('.qtiers__item-number').textContent = root.dataset.itemNumberTemplate.replace('__NUMBER__',index + 1);
          item.querySelectorAll('[data-qtiers-option]').forEach(select => {
            const label = select.parentElement.querySelector('label');
            select.id += '-extra-' + (index + 1);
            label.htmlFor = select.id;
            select.setAttribute('aria-label',root.dataset.itemOptionTemplate.replace('__NUMBER__',index + 1).replace('__OPTION__',label.textContent));
          });
          choices.appendChild(item);
          index++;
        }
      }
      function renderItem(item, index, count) {
        const slot = slots[index];
        const detail = data.details[slot.id];
        const v = data.variants[slot.id];
        item.dataset.variantId = slot.id;
        const thumbnail = item.querySelector('[data-qtiers-image]');
        if (detail.image) thumbnail.src = detail.image;
        else thumbnail.removeAttribute('src');
        thumbnail.hidden = !detail.image;
        item.classList.toggle('qtiers__item--without-image', !detail.image);
        item.querySelector('[data-qtiers-item-price]').textContent = money(v[0] - Math.floor(v[0] * percentFor(count) / 100));
        item.querySelectorAll('[data-qtiers-option]').forEach(function(select) {
          const optionIndex = Number(select.dataset.qtiersOption);
          select.value = detail.options[optionIndex];
          for (const option of select.options) {
            option.disabled = !Object.entries(data.details).some(([id,candidate]) => data.variants[id][1] && data.variants[id][2] > 0 && candidate.options[optionIndex] === option.value && candidate.options.slice(0,optionIndex).every((value,j) => value === detail.options[j]));
          }
        });
      }
      function sync() {
        const id = String(variant.value);
        const v = data.variants[id];
        root.hidden = !v || !v[1];
        if (root.hidden) return;
        if (id !== previousVariant) {
          slots.forEach(slot => {if (!slot.dirty) slot.id = id;});
          previousVariant = id;
        }
        const totalCapacity = canMix ? Math.min(99, Object.values(data.variants).reduce((sum,v) => sum + (v[1] ? Math.max(0,v[2]) : 0),0)) : v[2];
        qty.min = v[4]; qty.max = totalCapacity; qty.step = v[5];
        let count = Math.max(v[4], Math.min(totalCapacity, parseInt(qty.value,10) || v[4]));
        count = v[4] + Math.floor((count-v[4])/v[5]) * v[5];
        qty.value = count;
        const tierThreeMinimum = v[4] + Math.ceil((Math.max(3,v[4])-v[4])/v[5]) * v[5];
        ensureSlots(Math.max(count,tierThreeMinimum));
        quantityControl.hidden = count < 3;
        countInput.min = tierThreeMinimum;
        countInput.max = totalCapacity;
        countInput.step = v[5];
        countInput.value = count;
        decrease.disabled = count - v[5] < tierThreeMinimum;
        increase.disabled = count + v[5] > totalCapacity;
        rows.forEach(function(row) {
          const n = Number(row.dataset.qtiersOpt);
          const radio = row.querySelector('.qtiers__radio');
          const cardCount = n === 3 ? (count >= 3 ? count : tierThreeMinimum) : n;
          radio.disabled = cardCount > totalCapacity || cardCount < v[4] || (cardCount-v[4]) % v[5] !== 0;
          radio.checked = n === 3 ? count >= 3 : n === count;
          row.classList.toggle('is-selected',radio.checked);
          row.classList.toggle('is-disabled',radio.disabled);
          const result = selectionFor(cardCount);
          row.querySelector('[data-qtiers-total]').textContent = money(result.error ? cardCount * (v[0] - Math.floor(v[0] * percentFor(cardCount)/100)) : result.total);
          row.querySelector('[data-qtiers-orig]').textContent = money(result.error ? cardCount * v[0] : result.original);
          const unit = row.querySelector('.qtiers__unit');
          const mixed = canMix && cardCount > 1 && new Set(slots.slice(0,cardCount).map(s=>s.id)).size > 1;
          if (unit) {unit.hidden = mixed; unit.querySelector('[data-qtiers-unit]').textContent = money(v[0] - Math.floor(v[0]*percentFor(n)/100));}
          const birds = row.querySelector('[data-qtiers-count]');
          if(birds) birds.textContent = root.dataset.countTemplate.replace('__COUNT__',result.error ? cardCount*v[3] : result.birds);
        });
        if (choices) {
          choices.hidden = !canMix || count < 2;
          if (!choices.hidden) ensureRows(count);
          choices.querySelectorAll('[data-qtiers-item]').forEach(function(item) {
            const index = Number(item.dataset.qtiersItem);
            item.hidden = choices.hidden || index >= count;
            if (!item.hidden) renderItem(item,index,count);
            item.querySelectorAll('select').forEach(select => {select.disabled = item.hidden;});
          });
        }
        const current = selectionFor(count);
        const mixed = canMix && count >= 2 && (current.items?.length > 1 || slots[0].id !== id);
        if (checkout) checkout.hidden = mixed || Boolean(current.error);
        checkoutNote.hidden = !mixed;
        errorNode.hidden = !current.error;
        errorNode.textContent = current.error ? root.dataset.mixError : '';
        const total = current.error ? '' : money(current.total);
        summary.textContent = current.error ? '' : root.dataset.summaryTemplate.replace('__COUNT__',count).replace('__TOTAL__',total);
        const stickyPrice = form.querySelector('[data-mobile-sticky-price]');
        const stickyStatus = form.querySelector('[data-mobile-sticky-status]');
        if(stickyPrice) stickyPrice.textContent = total;
        if(stickyStatus) stickyStatus.textContent = mixed ? root.dataset.mixNote : count + ' × ' + (labels[id] || '');
      }
      root.getCartSelection = function() {
        if (!canMix || root.hidden) return null;
        const count = parseInt(qty.value,10);
        return count >= 2 ? selectionFor(count) : null;
      };
      root.syncQuantityOffer = sync;
      root.addEventListener('click',function(event) {
        const button = event.target.closest('[data-qtiers-decrease], [data-qtiers-increase]');
        if (!button || button.disabled) return;
        event.preventDefault();
        const delta = button === increase ? Number(countInput.step) : -Number(countInput.step);
        qty.value = Math.max(Number(countInput.min),Math.min(Number(countInput.max),Number(qty.value) + delta));
        qty.dispatchEvent(new Event('change',{bubbles:true}));
      });
      root.addEventListener('change',function(event) {
        if(event.target.matches('.qtiers__radio')) {
          event.stopPropagation();
          qty.value = event.target.value === '3' ? countInput.min : event.target.value;
          qty.dispatchEvent(new Event('change',{bubbles:true}));
        } else if(event.target === countInput) {
          event.stopPropagation();
          qty.value = countInput.value;
          qty.dispatchEvent(new Event('change',{bubbles:true}));
        } else if(event.target.matches('[data-qtiers-option]')) {
          event.stopPropagation();
          const item=event.target.closest('[data-qtiers-item]');
          const index=Number(item.dataset.qtiersItem);
          const selected=Array.from(item.querySelectorAll('[data-qtiers-option]'),select=>select.value);
          const changedIndex=Number(event.target.dataset.qtiersOption);
          const candidates=Object.entries(data.details).filter(([id,detail])=>data.variants[id][1] && data.variants[id][2] > 0 && detail.options.slice(0,changedIndex+1).every((v,j)=>v===selected[j]));
          const candidate=candidates.find(([,detail])=>detail.options.every((v,j)=>v===selected[j])) || candidates[0];
          if(candidate) {slots[index]={id:candidate[0],dirty:true};}
          sync();
        }
      });
      form.addEventListener('change',function(){queueMicrotask(sync);});
      form.addEventListener('input',function(event){if(event.target===qty) sync();});
      root.setAttribute('data-qtiers-ready','true');
      sync();
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){initQuantityOffers(document);});
  else initQuantityOffers(document);
  document.addEventListener('shopify:section:load',function(event){initQuantityOffers(event.target);});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["share-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-copy-url]');
    if (!btn) return;
    var url = btn.getAttribute('data-copy-url');
    navigator.clipboard.writeText(url);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["swatch-selector"] && !Shopify.designMode) return;
  try {
    (function() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-swatch-value]');
      if (!btn) return;

      var container = btn.closest('[data-swatch-selector]');
      if (!container) return;

      var value = btn.getAttribute('data-swatch-value');
      var hiddenSelect = container.querySelector('[data-product-option]');

      /* Update active state on buttons */
      container.querySelectorAll('[data-swatch-value]').forEach(function(b) {
        var isActive = b === btn;
        b.classList.toggle('swatch-selector__btn--active', isActive);
        b.setAttribute('aria-pressed', String(isActive));
        b.setAttribute('aria-checked', String(isActive));
      });

      /* Sync hidden select and trigger change for variant JS */
      if (hiddenSelect) {
        hiddenSelect.value = value;
        hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
